import React, { useEffect, useRef, useState } from 'react';
import { Search, X, Check } from 'lucide-react';
import { apiGet } from '../../lib/api';

let _cache = null;
async function fetchEmployees() {
  if (_cache) return _cache;
  try {
    const list = await apiGet('/hr/employees');
    _cache = (list || []).map((e) => ({ id: e.id, name: e.name, emp_id: e.emp_id, department: e.department, email: e.email }));
  } catch { _cache = []; }
  return _cache;
}

/**
 * Single-select employee picker that yields the full employee object (with id).
 * Props: value (employee obj|null), onSelect(emp), placeholder, testid.
 */
export default function EmployeeSelect({ value = null, onSelect, placeholder = 'Search employee…', testid }) {
  const [emps, setEmps] = useState([]);
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const root = useRef(null);

  useEffect(() => { fetchEmployees().then(setEmps); }, []);
  useEffect(() => {
    const h = (e) => { if (root.current && !root.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const filtered = !q ? emps.slice(0, 50) : emps.filter((e) =>
    (e.name || '').toLowerCase().includes(q.toLowerCase()) || (e.emp_id || '').toLowerCase().includes(q.toLowerCase())).slice(0, 50);

  return (
    <div ref={root} className="relative" data-testid={testid}>
      {value ? (
        <div className="flex items-center justify-between border border-slate-200 rounded-sm px-3 py-2 text-sm bg-slate-50">
          <span><span className="font-display font-bold">{value.name}</span> <span className="text-slate-400 text-xs">· {value.department || value.emp_id || ''}</span></span>
          <button type="button" onClick={() => onSelect(null)} data-testid={`${testid}-clear`}><X size={14} className="text-slate-400" /></button>
        </div>
      ) : (
        <div className="border border-slate-200 rounded-sm">
          <div className="flex items-center gap-2 px-2 py-2">
            <Search size={14} className="text-slate-400" />
            <input className="flex-1 text-sm outline-none" placeholder={placeholder} value={q}
              onFocus={() => setOpen(true)} onChange={(e) => { setQ(e.target.value); setOpen(true); }} data-testid={`${testid}-input`} />
          </div>
          {open && (
            <div className="max-h-52 overflow-y-auto border-t border-slate-100">
              {filtered.length === 0 ? <div className="text-xs text-slate-400 p-3">No employees found.</div> : filtered.map((e) => (
                <button type="button" key={e.id} onClick={() => { onSelect(e); setOpen(false); setQ(''); }} data-testid={`${testid}-opt-${e.id}`}
                  className="w-full flex items-center justify-between px-3 py-2 text-sm text-left hover:bg-slate-50">
                  <span>{e.name} <span className="text-slate-400 text-xs">· {e.department || e.emp_id || ''}</span></span>
                  <Check size={14} className="text-slate-300" />
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
